import { render, staticRenderFns } from "./ModalExcluirRevisao.vue?vue&type=template&id=2541c591"
import script from "./ModalExcluirRevisao.vue?vue&type=script&lang=js"
export * from "./ModalExcluirRevisao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports